/**
 * Keep the reskin sticky CTA pinned to the viewport bottom, then lift it so
 * the site footer sits below the bar when the participant reaches the page end.
 *
 * While a text field is focused, leave the bar at the viewport bottom. On iOS
 * WebKit, position:fixed bottom:0 follows the visual viewport (top of the
 * keyboard), so shift the bar down by the occluded band. Android stays at 0.
 */
$(() => {
  const { body } = document;

  if (
    !body.classList.contains('reg-checkout-reskin')
    || !body.classList.contains('event-registration-shell')
    || body.classList.contains('kiosk-registration')
  ) {
    return;
  }

  const footer = document.getElementById('footer');
  const bars = document.querySelectorAll('[data-js-sticky-progression]');

  if (!footer || !bars.length) {
    return;
  }

  let ticking = false;

  const isIos = /iPad|iPhone|iPod/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const isTouchDevice = () => window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  const textEntryFocused = () => {
    const el = document.activeElement;

    if (!el || el === body) {
      return false;
    }

    if (el.isContentEditable || el.tagName === 'TEXTAREA') {
      return true;
    }

    if (el.tagName !== 'INPUT') {
      return false;
    }

    const type = (el.getAttribute('type') || 'text').toLowerCase();

    return [
      'button',
      'checkbox',
      'color',
      'file',
      'hidden',
      'image',
      'radio',
      'range',
      'reset',
      'submit',
    ].indexOf(type) === -1;
  };

  // Safari paints fixed bottom:0 at the visual bottom (top of the keyboard).
  // A negative offset moves the bar down to the layout bottom, behind the keys.
  const iosKeyboardOffset = () => {
    const { visualViewport } = window;

    if (!visualViewport) {
      return 0;
    }

    return -(Math.max(
      0,
      window.innerHeight - visualViewport.offsetTop - visualViewport.height,
    ));
  };

  const stickyBottom = () => {
    if (textEntryFocused() && isTouchDevice()) {
      if (isIos) {
        return iosKeyboardOffset();
      }

      return 0;
    }

    return Math.max(0, window.innerHeight - footer.getBoundingClientRect().top);
  };

  const pinBars = () => {
    const bottomPx = `${stickyBottom()}px`;

    bars.forEach((bar) => {
      bar.style.bottom = bottomPx;
    });

    ticking = false;
  };

  const schedulePin = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(pinBars);
  };

  window.addEventListener('scroll', schedulePin, { passive: true });
  window.addEventListener('resize', schedulePin);
  window.addEventListener('load', schedulePin);
  document.addEventListener('focusin', schedulePin);
  document.addEventListener('focusout', schedulePin);

  if (isIos && window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedulePin);
    window.visualViewport.addEventListener('scroll', schedulePin, { passive: true });
  }

  if (typeof ResizeObserver === 'function') {
    const resizeObserver = new ResizeObserver(schedulePin);
    resizeObserver.observe(document.body);
  }

  if (typeof IntersectionObserver === 'function') {
    const intersectionObserver = new IntersectionObserver(schedulePin);
    intersectionObserver.observe(footer);
  }

  pinBars();
});
